<template>
  <div>
     <b-form-group>
            <autocomplete
                ref="autocomplete"
                :maxlength="4"
                :source="fetchOrderLists"
                results-property="orderLists"
                results-value="id"
                results-display="name"
                :request-headers="authHeaders"
                @selected="selectedOrderList"
                input-class="form-control form-control-lg"
                placeholder="Search List"
                >
              </autocomplete>

              
     </b-form-group>
            
  </div>
</template>

<script>
import Autocomplete from 'vuejs-auto-complete'
import authHeader from "../../../services/auth-header";
import { mapGetters } from 'vuex'

import { API_URL } from "../../../services/constants";
import EventBus from '../../../EventBus';

  export default {
    data(){
      return {
        selectedList: {}
      }
    },
    components: {Autocomplete},
    mounted(){
       
    },
    methods: {
        fetchOrderLists(input){
          return `${API_URL}orders-list/fetch-order-lists/${input}`  
       },
       selectedOrderList(list){
          this.selectedList = list;
          this.$refs.autocomplete.clear()

          // Set as active list in state

          let data = {action: "add", orderList:{name: this.selectedList.display, value: this.selectedList.value}};
          this.$store.dispatch('ordersList/addOrRemoveActiveList', data)

          // 
          //EventBus.$emit('orders-list-selected', list.value)
       },
       
    },
    computed: {
       authHeaders(){
         return authHeader();
       },
       activeList(){
         return this.$store.state.ordersList.activeList
       }
    }
  }
</script>

<style lang="scss" scoped>

</style>